module.exports = __webpack_public_path__ + "img/logo.c6411570.png";